import styled from 'styled-components';

export const TopBar = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.border};
  padding: ${({ theme }) => `${theme.spacing.md} ${theme.spacing.lg}`};
`;

export const TopBarInner = styled.div`
  max-width: 48rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.md};
`;

export const Logo = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  text-decoration: none;
`;

export const LogoMark = styled.span`
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 0.8rem;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.accent} 0%,
    ${({ theme }) => theme.colors.accentDark} 100%
  );
  color: ${({ theme }) => theme.colors.white};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.05rem;
`;

export const LogoWordmark = styled.span`
  font-size: 1.7rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  letter-spacing: -0.03rem;
`;

export const PromoCta = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 1.2rem;
  border-radius: 999rem;
  background-color: rgba(14, 165, 233, 0.1);
  color: ${({ theme }) => theme.colors.accent};
  font-size: 1.2rem;
  font-weight: 700;
  text-decoration: none;
  border: 0.1rem solid rgba(14, 165, 233, 0.32);
`;
